// Central content/data source for Prime Path Partners (P3)
// Rebranded content adapted from original site verbiage (ASO -> P3)

export const brand = {
  name: "Prime Path Partners",
  shortName: "P3",
  logo: "https://customer-assets.emergentagent.com/job_50d5fa92-dc47-4e0a-b195-ae9f004ab3cc/artifacts/pz5strfs_3P%20Logo.png",
  domain: "PrimePathPartners.net",
};

export const contact = {
  address: "100 Crescent Court Uptown, 7th Floor, Dallas, TX 75201",
  phone: "972-388-0024",
  phoneHref: "+19723880024",
  email: "Support@PrimePathPartners.net",
  hours: "8:00 AM to 10 PM CST Time",
};

export const social = {
  facebook: "#",
  youtube: "#",
  instagram: "#",
  linkedin: "#",
};

export const navLinks = [
  { label: "Home", href: "/" },
  {
    label: "Product",
    href: "/shop",
    dropdown: [
      { label: "Web Design", href: "/shop/web-design" },
      { label: "View Shop", href: "/shop" },
    ],
  },
  { label: "Terms & Conditions", href: "/terms-conditions" },
  { label: "About Us", href: "/about-us" },
  { label: "Contact", href: "/contact" },
];

export const images = {
  heroIllustration: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85",
  heroIllustration2: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&q=85",
  mission: "https://images.unsplash.com/photo-1471958680802-1345a694ba6d?crop=entropy&cs=srgb&fm=jpg&q=85",
  founder: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85",
  dashboard: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?crop=entropy&cs=srgb&fm=jpg&q=85",
  brisbane: "https://images.unsplash.com/photo-1756805115188-d72c077932fb?crop=entropy&cs=srgb&fm=jpg&q=85",
  usaCanada: "https://images.unsplash.com/photo-1496588152823-86ff7695e68f?crop=entropy&cs=srgb&fm=jpg&q=85",
  turkeyArmenia: "https://images.unsplash.com/photo-1696711551721-458511adcd86?crop=entropy&cs=srgb&fm=jpg&q=85",
  dallas: "https://images.unsplash.com/photo-1621904878414-d4ca4756bd7e?crop=entropy&cs=srgb&fm=jpg&q=85",
  austin: "https://images.unsplash.com/photo-1557335200-a65f7f032602?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const hero = {
  headline: ["Launch, Grow &", "Optimize your", "Brand on "],
  headlineHighlight: "Amazon",
  subheadline: "It's all about cash flow management & Minimizing risks",
  ctaPrimary: { label: "Free Analysis", href: "/free-analysis" },
  ctaSecondary: { label: "Free Consultation", href: "/contact" },
};

export const services = [
  {
    slug: "product-selection",
    title: "Product Selection",
    icon: "Search",
    body: "You will learn how to pick a winning product. Our intellectual property will help you decide on a product based on analysis. We don't use simple tools like Jungle Scout and outdated databases. We will teach you strategies that will help you succeed. It's all about making a difference in the market.",
  },
  {
    slug: "product-sourcing",
    title: "Product Sourcing",
    icon: "Package",
    body: "We will coach you through the process of finding a reliable supplier. We will make sure you obtain your samples and source your order securely. In this step we will also teach you about the graphics and the packaging.",
  },
  {
    slug: "product-launch",
    title: "Product Launch",
    icon: "Rocket",
    body: "Once your product arrives at the Amazon warehouse, it will become available on the Amazon website for people to order from. The next step is getting reviews and focusing on marketing. We have a team of experts from around the world to guide you in this stage.",
  },
  {
    slug: "sellers-website-design",
    title: "Sellers Website Design",
    icon: "LayoutTemplate",
    body: "You do not want to sell and showcase your products on Amazon only, it's best for you to setup and work on your personal website from the beginning. We will help you setup a unique ecommerce website for your brand and make it shine.",
  },
  {
    slug: "amazon-brand-management",
    title: "Amazon Brand Management",
    icon: "BriefcaseBusiness",
    body: "Are you tired of employees telling you they can handle the marketing of your Amazon product? Do you need to partner with a professional team of Amazon sellers that know what they are talking about? Do you simply need someone to manage your day to day Amazon interactions?",
  },
  {
    slug: "amazon-fba-consultant",
    title: "Amazon FBA Consultant",
    icon: "GraduationCap",
    body: "Are you just starting out and need to know where to set your sights on the correct tools to use, and the most efficient way to market your product? Or is your marketing department in need of in depth marketing tactics that are compliant with Amazon's rules and regulations? Contact us now.",
  },
];

export const brandQuote =
  "A BRAND FOR A COMPANY IS LIKE A REPUTATION FOR A PERSON. YOU EARN REPUTATION BY TRYING TO DO HARD THINGS WELL.";

export const differenceBlocks = [
  {
    title: "We are a team of Amazon Experts",
    body: "We've worked with Amazon for a long time. Let us help you design an engaging listing for your Amazon goods so that it stands out from the crowd. By promoting your business on both Amazon and your own e-commerce website, we'll help you avoid suspension and increase sales at the same time.",
  },
  {
    title: "We get to know you first",
    body: "Every brand and product is different. After completing our study on your niche and your products, we will develop a unique marketing approach. In contrast to other Brand Management businesses that concentrate exclusively on the market as a whole, we consider your specific brand, financial condition, and unique product ideas before establishing a strategy that is specifically adapted to your needs.",
  },
  {
    title: "Tools you never heard of",
    body: "We are an Amazon brand management agency that provides you with a competitive advantage by utilising high-end solutions.",
  },
  {
    title: "Proven Reverse Strategies",
    body: "Reverse engineering your product's niche is part of our approach to ensure that we grow your success. Due to our expertise on Amazon, every back-end seller's activity is well known to us.",
  },
  {
    title: "See for yourself report",
    body: "You'll get a monthly progress report with figures and rates.",
  },
];

export const ctaSections = {
  getAhead: {
    headline: "Get ahead on Amazon",
    body: "Take your business to the next level. Get managed services by our Amazon experts.",
    cta: "Schedule a Free Consultation",
    href: "/contact",
  },
  freeAnalysis: {
    headline: "Get a Free Amazon Brand Analysis",
    body: "One of our Amazon optimisation consultants will assess your brand and recommend improvements.",
    cta: "Get Your Free Analysis",
    href: "/free-analysis",
  },
};

export const stats = {
  headline: "Maximize Your Success Rate",
  subheadline: "Research | Implementation | Strategy",
  items: [
    { value: "$10+ Million", label: "in online sales" },
    { value: "1,000+ clients", label: "growing daily" },
    { value: "6+ Years", label: "Amazon, e-commerce & digital marketing experience" },
  ],
};

export const leadForm = {
  title: "Let us help you now!",
  successMessage: "Thank you! Your request has been received. Our team will review your information and follow up with next steps.",
};

export const newsletter = {
  title: "Want to know more about Amazon",
  placeholder: "Email",
  button: "Subscribe me",
};

export const footerIntro =
  "With more than 6 years of experience on Amazon, and a team of international experts from all over the world, we are ready to take your business to the next level. Selling on Amazon is easy, sourcing a product is easier, but are you doing it the right way?";

export const ourDifferenceQuote = {
  title: "OUR DIFFERENCE",
  lines: [
    "P3 is here to make sure you are on the right track.",
    "P3 is here to be with you so you won't feel alone. P3 is here to take care of your business for you with your help so you can learn the process the right way.",
  ],
};

export const footerLinks = [
  { label: "Product Launch", href: "/#services" },
  { label: "Web Design", href: "/shop/web-design" },
  { label: "Graphic Design", href: "/shop" },
];

export const mission = {
  headline: "Our Mission & Vision",
  intro:
    "Our mission is not to make you millionaires, but to help you get there. We are on the path and onboarding as many individuals as we can, getting on board before we set sail.",
  notList: [
    "To solely coach you or to sell you a course",
    "To leave you alone in the middle of the tides",
    "To make you a millionaire in a year",
    "To show you how easy it is to sell on Amazon",
  ],
  closing:
    "We are waiting for you, no matter how hard the process is and how much you feel alone in this journey, we are a team and we are with you.",
  quote: "The journey of a thousand miles begins with one step.",
};

export const founder = {
  name: "Ahmed Qwazelbash",
  role: "Founder & CEO",
  bio:
    "Ahmed Qwazelbash is an Industrial Engineer / e-commerce expert with more than 10 years of experience in the field. He has worked in multiple factories in the field of quality control and visited various production lines. Soon after entering e-commerce he felt the demanding opportunities awaited for him. He mastered all techniques and strategies for an online business to harness the power of Amazon to its fullest. Now he has launched more than 4 brands on Amazon.com and is growing even more.",
};

export const contactPage = {
  headline: "Everything will start with your message",
  regions: [
    { title: "Dallas, TX", detail: "United States", image: images.dallas },
    { title: "Austin, TX", detail: "United States", image: images.austin },
    { title: "Brisbane Australia", detail: "Australia", image: images.brisbane },
    { title: "USA & Canada", detail: "United States, Canada", image: images.usaCanada },
    { title: "Turkey & Armenia", detail: "Turkey, Armenia", image: images.turkeyArmenia },
  ],
  contactReasons: [
    "eCommerce Services",
    "Marketing and Growth",
    "Amazon Brand Management",
    "Team building and Coaching",
    "Others",
  ],
  successMessage: "Thanks for reaching out. Your message has been received and our team will be in touch shortly.",
};

export const shopProduct = {
  slug: "web-design",
  name: "Web Design",
  category: "SEO Service",
  image: brand.logo,
  minPrice: 30,
  maxPrice: 480,
  description:
    "A complete SEO-optimized ecommerce website build for your brand, designed to complement your Amazon presence and drive independent sales.",
  seoOptions: ["01 Month", "03 Months", "06 Months", "12 Months"],
  // Real pricing model from live-action-service-sv store:
  // 1 Month = base rate, 3/6/12 Months apply a discount multiplier to the monthly rate.
  seoMultipliers: { "01 Month": 1, "03 Months": 2.7, "06 Months": 5.1, "12 Months": 9.6 },
  seoBillingLabel: { "01 Month": "", "03 Months": "Quarterly", "06 Months": "Semi-Annually", "12 Months": "Annually" },
  seoDiscountLabel: { "01 Month": "", "03 Months": "10% Discount", "06 Months": "15% Discount", "12 Months": "20% Discount" },
  websiteOptions: ["1 Website", "2 Websites", "3 Websites", "4 Websites", "5 Websites"],
  // Monthly rate per number of websites ($30 base + $5 per additional website)
  websiteMonthlyPrice: { "1 Website": 30, "2 Websites": 35, "3 Websites": 40, "4 Websites": 45, "5 Websites": 50 },
};

export const legalUpdatedDate = "July 9, 2025";
